/**
 * Where the family's nav and footer go. The family's own pages (its landing, pricing and the five solutions)
 * live at FAMILY_SITE: NEXT_PUBLIC_FAMILY_SITE where it is set (prod sets it to wherever those pages live
 * then), else the family's preview. Every other link is a page of this app.
 */
export const FAMILY_SITE = (
  process.env.NEXT_PUBLIC_FAMILY_SITE || "https://vestra-new.vercel.app"
).replace(/\/+$/, "");

export interface FamilyLink {
  label: string;
  href: string;
}

export const PRODUCT: readonly FamilyLink[] = [
  { label: "Bash", href: `${FAMILY_SITE}/#bash` },
  { label: "Brain", href: `${FAMILY_SITE}/#brain` },
  { label: "Teammates", href: `${FAMILY_SITE}/#shape` },
  { label: "Pricing", href: `${FAMILY_SITE}/pricing` },
];

/** The Solutions menu, each page with what it is for, in the family's words. */
export const SOLUTIONS: ReadonlyArray<
  FamilyLink & { slug: string; says: string }
> = [
  {
    slug: "personal",
    label: "Personal",
    says: "Your own team for life admin and side projects.",
  },
  {
    slug: "solopreneurs",
    label: "Solopreneurs",
    says: "Run a one-person business like a company of 100.",
  },
  {
    slug: "smb",
    label: "SMB",
    says: "A team that runs the busywork of a growing business.",
  },
  {
    slug: "startup",
    label: "Startup",
    says: "A founding team from day one, without the payroll.",
  },
  {
    slug: "enterprise",
    label: "Enterprise",
    says: "Security, controls and a team for every department.",
  },
].map((s) => ({ ...s, href: `${FAMILY_SITE}/solutions/${s.slug}` }));

export const HOME = `${FAMILY_SITE}/`;
export const DEVELOPERS = "/developers";
export const TEST_KEY = "/developers/console";
export const QUICKSTART = "/developers/quickstart";

/** The footer's columns after the brand: the family's, with a Developers column. */
export const FOOTER: ReadonlyArray<{
  title: string;
  links: readonly FamilyLink[];
}> = [
  { title: "Product", links: PRODUCT },
  {
    title: "Developers",
    links: [
      { label: "Quickstart", href: QUICKSTART },
      { label: "Guides", href: "/developers/guides" },
      { label: "Reference", href: "/developers/reference" },
      { label: "Changelog", href: "/developers/changelog" },
      { label: "Get a test key", href: TEST_KEY },
    ],
  },
  { title: "Solutions", links: SOLUTIONS },
  {
    title: "Learn",
    links: [
      { label: "The handbook", href: "/handbook" },
      { label: "Compare Vestra", href: "/vs" },
      { label: "Blog", href: "/blogs" },
      {
        label: "Book a call",
        href: "https://calendly.com/keshav-vestra/vestra-onboarding",
      },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy policy", href: "/policies/privacy" },
      { label: "Terms of service", href: "/policies/terms" },
      { label: "Refund policy", href: "/policies/refund" },
    ],
  },
];
